import React, { useState, useEffect } from 'react';
import Header from "../../Layouts/Header";
import Footer from "../../Layouts/Footer";
import { Card, CardContent, Grid, TextField, FormControl, InputLabel, Select, MenuItem, Button, Typography } from '@material-ui/core';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Authapi from '../../Services/Authapi';
import swal from 'sweetalert';
import AuthCheckComponent from '../../Layouts/Token';
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

export default function Reviewformedit(props) {
    const [data, setdata] = useState({
        form_name: '',
        form_details: [],
        form_content: []
    });
    const [formErrors, setFormErrors] = useState({});
    const classes = props;

    const getMainLabelErrorKey = (inputIndex) => `main_label_${inputIndex}`;
    const getMainTypeErrorKey = (inputIndex) => `main_type_${inputIndex}`;
    const getMainOptionErrorKey = (inputIndex, optionIndex) => `main_option_${inputIndex}_${optionIndex}`;
    const getMainOptionsGroupErrorKey = (inputIndex) => `main_options_group_${inputIndex}`;
    const getContentTitleErrorKey = (contentIndex) => `content_title_${contentIndex}`;
    const getContentLabelErrorKey = (contentIndex) => `content_label_${contentIndex}`;
    const getContentTypeErrorKey = (contentIndex) => `content_type_${contentIndex}`;
    const getContentOptionErrorKey = (contentIndex, optionIndex) => `content_option_${contentIndex}_${optionIndex}`;
    const getContentOptionsGroupErrorKey = (contentIndex) => `content_options_group_${contentIndex}`;

    const normalizeOptions = (options) => Array.isArray(options) ? options : [];
    const getNormalizedLabel = (item = {}) => item.label || item.input_label || item.content_label || item.name || '';
    const getNormalizedTitle = (item = {}) => item.title || item.form_title || '';
    const normalizeFormDetail = (item = {}) => ({
        ...item,
        label: getNormalizedLabel(item),
        type: item.type || '',
        options: normalizeOptions(item.options)
    });
    const normalizeFormContent = (item = {}) => ({
        ...item,
        title: getNormalizedTitle(item),
        label: getNormalizedLabel(item),
        type: item.type || '',
        options: normalizeOptions(item.options)
    });

    const clearError = (key) => {
        setFormErrors((prevState) => {
            if (!prevState[key]) {
                return prevState;
            }

            const updatedErrors = { ...prevState };
            delete updatedErrors[key];
            return updatedErrors;
        });
    };

    const validateForm = () => {
        const errors = {};

        if (!data.form_name?.trim()) {
            errors.form_name = "Form name is required";
        }

        data.form_details.forEach((input, inputIndex) => {
            if (!input.label?.trim()) {
                errors[getMainLabelErrorKey(inputIndex)] = "Input label is required";
            }

            if (!input.type?.trim()) {
                errors[getMainTypeErrorKey(inputIndex)] = "Input type is required";
            }

            if (input.type === 'radio' || input.type === 'checkbox') {
                const validOptions = (input.options || []).filter((option) => option?.trim());
                if (validOptions.length === 0) {
                    errors[getMainOptionsGroupErrorKey(inputIndex)] = "At least one option is required";
                }

                (input.options || []).forEach((option, optionIndex) => {
                    if (!option?.trim()) {
                        errors[getMainOptionErrorKey(inputIndex, optionIndex)] = "Option is required";
                    }
                });
            }
        });

        data.form_content.forEach((content, contentIndex) => {
            if (!content.title?.trim()) {
                errors[getContentTitleErrorKey(contentIndex)] = "Form title is required";
            }

            if (!content.label?.trim()) {
                errors[getContentLabelErrorKey(contentIndex)] = "Content label is required";
            }

            if (!content.type?.trim()) {
                errors[getContentTypeErrorKey(contentIndex)] = "Input type is required";
            }

            if (content.type === 'radio' || content.type === 'checkbox') {
                const validOptions = (content.options || []).filter((option) => option?.trim());
                if (validOptions.length === 0) {
                    errors[getContentOptionsGroupErrorKey(contentIndex)] = "At least one option is required";
                }

                (content.options || []).forEach((option, optionIndex) => {
                    if (!option?.trim()) {
                        errors[getContentOptionErrorKey(contentIndex, optionIndex)] = "Option is required";
                    }
                });
            }
        });

        return errors;
    };

    useEffect(() => {
        Reviewformlist();
    }, []);

    const Reviewformlist = async () => {
        let Id = props.history.location.pathname.split('/').pop();
        try {
            let role = await Authapi.ReviewformlistgetformbyID(Id);
            setdata({
                form_name: role.data.form_name || '',
                form_details: (role.data.form_details || []).map(normalizeFormDetail),
                form_content: (role.data.form_content || []).map(normalizeFormContent)
            });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleInputChange = (index, field, value) => {
        const newDetails = [...data.form_details];
        newDetails[index][field] = value;
        if (field === 'type' && (value === 'radio' || value === 'checkbox')) {
            newDetails[index].options = newDetails[index].options || [];
        } else if (field === 'type') {
            newDetails[index].options = [];
        }
        setdata(prevState => ({
            ...prevState,
            form_details: newDetails
        }));
        if (field === 'label') {
            clearError(getMainLabelErrorKey(index));
        }
        if (field === 'type') {
            clearError(getMainTypeErrorKey(index));
            clearError(getMainOptionsGroupErrorKey(index));
        }
    };

    const handleContentChange = (index, field, value) => {
        const newContent = [...data.form_content];
        newContent[index][field] = value;
        if (field === 'type' && (value === 'radio' || value === 'checkbox')) {
            newContent[index].options = newContent[index].options || [];
        } else if (field === 'type') {
            newContent[index].options = [];
        }
        setdata(prevState => ({
            ...prevState,
            form_content: newContent
        }));
        if (field === 'title') {
            clearError(getContentTitleErrorKey(index));
        }
        if (field === 'label') {
            clearError(getContentLabelErrorKey(index));
        }
        if (field === 'type') {
            clearError(getContentTypeErrorKey(index));
            clearError(getContentOptionsGroupErrorKey(index));
        }
    };

    const handleOptionChange = (inputIndex, optionIndex, value) => {
        const newDetails = [...data.form_details];
        if (newDetails[inputIndex] && newDetails[inputIndex].options) {
            newDetails[inputIndex].options[optionIndex] = value;
            setdata(prevState => ({
                ...prevState,
                form_details: newDetails
            }));
            clearError(getMainOptionErrorKey(inputIndex, optionIndex));
            clearError(getMainOptionsGroupErrorKey(inputIndex));
        }
    };

    const handleContentOptionChange = (contentIndex, optionIndex, value) => {
        const newContent = [...data.form_content];
        if (newContent[contentIndex] && newContent[contentIndex].options) {
            newContent[contentIndex].options[optionIndex] = value;
            setdata(prevState => ({
                ...prevState,
                form_content: newContent
            }));
            clearError(getContentOptionErrorKey(contentIndex, optionIndex));
            clearError(getContentOptionsGroupErrorKey(contentIndex));
        }
    };

    const addMainOption = (inputIndex) => {
        setdata(prevState => {
            const newDetails = [...prevState.form_details];
            if (!newDetails[inputIndex].options) {
                newDetails[inputIndex].options = [];
            }
            newDetails[inputIndex].options.push('');
            return { ...prevState, form_details: newDetails };
        });
    };

    const removeMainOption = (inputIndex, optionIndex) => {
        setdata(prevState => {
            const newDetails = [...prevState.form_details];
            if (newDetails[inputIndex] && newDetails[inputIndex].options) {
                newDetails[inputIndex].options.splice(optionIndex, 1);
            }
            return { ...prevState, form_details: newDetails };
        });
    };

    const addContentOption = (contentIndex) => {
        setdata(prevState => {
            const newContent = [...prevState.form_content];
            if (!newContent[contentIndex].options) {
                newContent[contentIndex].options = [];
            }
            newContent[contentIndex].options.push('');
            return { ...prevState, form_content: newContent };
        });
    };

    const removeContentOption = (contentIndex, optionIndex) => {
        setdata(prevState => {
            const newContent = [...prevState.form_content];
            if (newContent[contentIndex] && newContent[contentIndex].options) {
                newContent[contentIndex].options.splice(optionIndex, 1);
            }
            return { ...prevState, form_content: newContent };
        });
    };

    const addMainInputField = () => {
        setdata(prevState => ({
            ...prevState,
            form_details: [...prevState.form_details, { type: '', label: '', options: [] }]
        }));
    };

    const removeMainInputField = (inputIndex) => {
        const newDetails = [...data.form_details];
        newDetails.splice(inputIndex, 1);
        setdata(prevState => ({
            ...prevState,
            form_details: newDetails
        }));
    };

    const addContentField = () => {
        setdata(prevState => ({
            ...prevState,
            form_content: [...prevState.form_content, { title: '', label: '', type: '', options: [] }]
        }));
    };

    const removeContentField = (contentIndex) => {
        const newContent = [...data.form_content];
        newContent.splice(contentIndex, 1);
        setdata(prevState => ({
            ...prevState,
            form_content: newContent
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const errors = validateForm();
        setFormErrors(errors);
        if (Object.keys(errors).length > 0) {
            return;
        }
        await createupdate();
    };





    const createupdate = async () => {
        const id = props.history.location.pathname.split('/').pop();
        swal({
            title: "Loading",
            text: "Please wait...",
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
            width: "10%",
            content: createSwalLoaderNode()
        });

        try {
            const transformedInputs = data.form_details.map(input => ({
                label: getNormalizedLabel(input),
                input_label: getNormalizedLabel(input),
                type: input.type,
                options: (input.type === 'radio' || input.type === 'checkbox') ? input.options : []
            }));

            const transformedPostTitles = data.form_content.map(content => ({
                title: getNormalizedTitle(content),
                form_title: getNormalizedTitle(content),
                label: getNormalizedLabel(content),
                content_label: getNormalizedLabel(content),
                type: content.type,
                options: (content.type === 'radio' || content.type === 'checkbox') ? content.options : []
            }));

            const postData = {
                form_name: data.form_name,
                form_details: transformedInputs,
                form_content: transformedPostTitles
            };

            let create = await Authapi.Reviewformupdate(postData, id);
            swal.close();
            if (create && create.status === true) {
                swal("Success", "Review form updated successfully", "success").then(() => {
                    props.history.push("/review-form-list");
                });
            } else {
                swal({
                    title: "OOPS!",
                    icon: "error",
                    text: create && create.message ? create.message : "Something went wrong, Please try later!",
                });
            }
        } catch (error) {
            swal.close();
            console.error("Error updating role:", error);
            swal("Error", "An unexpected error occurred", "error");
        }
    };

    return (
        <div>
            <AuthCheckComponent authToken={props.authToken} />
            <Header
                {...props}
                authUser={props.authUser}
                setAuthUser={props.setAuthUser}
                component={
                    <React.Fragment>
                        <div className="holiday-breadcrumb-card">
                            <Breadcrumb {...props}
                                primaryPageName="Review Form"
                                primaryPageLink="/review-form-list"
                                isSecondaryPage={true}
                                secondaryPageName="Edit Form" />
                        </div>
                        <Grid container className={classes.root} spacing={2} style={{ marginBottom: '80px' }}>
                            <Grid item xs={12}>
                                <div className="holiday-form-card">
                                    <Typography variant="h2" className="common-form-page-title holiday-form-title">Edit Form</Typography>
                                    <form className={classes.form} onSubmit={handleSubmit}>
                                            <Grid container className={classes.root} spacing={5}>
                                                <Grid item xs={12}>
                                                    <TextField
                                                        fullWidth
                                                        label="Form Name"
                                                        InputLabelProps={{ shrink: true }}
                                                        value={data.form_name}
                                                        onChange={(e) => {
                                                            setdata({ ...data, form_name: e.target.value });
                                                            clearError('form_name');
                                                        }}
                                                        error={Boolean(formErrors.form_name)}
                                                        helperText={formErrors.form_name || ''}
                                                    />
                                                </Grid>
                                            </Grid>
                                            {data.form_details.map((input, inputIndex) => (
                                                <Grid container spacing={2} key={inputIndex}>
                                                    <Grid item xs={5}>
                                                        <TextField
                                                            fullWidth
                                                            label={`Input Label ${inputIndex + 1}`}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={input.label}
                                                            onChange={(e) => handleInputChange(inputIndex, 'label', e.target.value)}
                                                            error={Boolean(formErrors[getMainLabelErrorKey(inputIndex)])}
                                                            helperText={formErrors[getMainLabelErrorKey(inputIndex)] || ''}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <FormControl fullWidth error={Boolean(formErrors[getMainTypeErrorKey(inputIndex)])}>
                                                            <InputLabel>Input Type</InputLabel>
                                                            <Select
                                                                value={input.type}
                                                                onChange={(e) => handleInputChange(inputIndex, 'type', e.target.value)}
                                                            >
                                                                <MenuItem value="text">Text</MenuItem>
                                                                <MenuItem value="date">Date</MenuItem>
                                                                <MenuItem value="email">Email</MenuItem>
                                                                <MenuItem value="number">Number</MenuItem>
                                                                <MenuItem value="textarea">Textarea</MenuItem>
                                                                <MenuItem value="checkbox">Checkbox</MenuItem>
                                                                <MenuItem value="radio">Radio</MenuItem>
                                                            </Select>
                                                            {formErrors[getMainTypeErrorKey(inputIndex)] && (
                                                                <span className="error">{formErrors[getMainTypeErrorKey(inputIndex)]}</span>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Button
                                                            type="button"
                                                            onClick={() => removeMainInputField(inputIndex)}
                                                            variant="contained"
                                                            style={{
                                                                color: "#fff",
                                                                backgroundColor: "#d12c2c",
                                                                marginTop: "10px",
                                                                textTransform: 'capitalize'
                                                            }}>
                                                            Remove
                                                        </Button>
                                                    </Grid>
                                                    {(input.type === 'radio' || input.type === 'checkbox') && (
                                                        <Grid item xs={12}>
                                                            {input.options && input.options.map((option, optionIndex) => (
                                                                <Grid container spacing={2} key={optionIndex}>
                                                                    <Grid item xs={8}>
                                                        <TextField
                                                            fullWidth
                                                            label={`Option ${optionIndex + 1}`}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={option}
                                                            onChange={(e) => handleOptionChange(inputIndex, optionIndex, e.target.value)}
                                                            error={Boolean(formErrors[getMainOptionErrorKey(inputIndex, optionIndex)])}
                                                                            helperText={formErrors[getMainOptionErrorKey(inputIndex, optionIndex)] || ''}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Button
                                                                            type="button"
                                                                            onClick={() => removeMainOption(inputIndex, optionIndex)}
                                                                            variant="contained"
                                                                            style={{
                                                                                color: "#fff",
                                                                                backgroundColor: "#d12c2c",
                                                                                marginTop: "10px",
                                                                                textTransform: 'capitalize'
                                                                            }}>
                                                                            Remove
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                            <Button
                                                                type="button"
                                                                onClick={() => addMainOption(inputIndex)}
                                                                variant="contained"
                                                                color="primary"
                                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                                Add Option
                                                            </Button>
                                                            {formErrors[getMainOptionsGroupErrorKey(inputIndex)] && (
                                                                <span className="error">{formErrors[getMainOptionsGroupErrorKey(inputIndex)]}</span>
                                                            )}
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            ))}
                                            <Button
                                                type="button"
                                                onClick={addMainInputField}
                                                variant="contained"
                                                color="primary"
                                                className="common-action-button"
                                                style={{ marginRight: "15px", marginTop: "10px", textTransform: 'capitalize' }}>
                                                Add Input
                                            </Button>
                                            {data.form_content.map((content, contentIndex) => (
                                                <Grid container spacing={2} key={contentIndex}>
                                                    <Grid item xs={12}>
                                                        <TextField
                                                            fullWidth
                                                            label={`Form Title ${contentIndex + 1}`}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={content.title}
                                                            onChange={(e) => handleContentChange(contentIndex, 'title', e.target.value)}
                                                            error={Boolean(formErrors[getContentTitleErrorKey(contentIndex)])}
                                                            helperText={formErrors[getContentTitleErrorKey(contentIndex)] || ''}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <TextField
                                                            fullWidth
                                                            label={`Content Label ${contentIndex + 1}`}
                                                            InputLabelProps={{ shrink: true }}
                                                            value={content.label}
                                                            onChange={(e) => handleContentChange(contentIndex, 'label', e.target.value)}
                                                            error={Boolean(formErrors[getContentLabelErrorKey(contentIndex)])}
                                                            helperText={formErrors[getContentLabelErrorKey(contentIndex)] || ''}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <FormControl fullWidth error={Boolean(formErrors[getContentTypeErrorKey(contentIndex)])}>
                                                            <InputLabel>Input Type</InputLabel>
                                                            <Select
                                                                value={content.type || ''}
                                                                onChange={(e) => handleContentChange(contentIndex, 'type', e.target.value)}
                                                            >
                                                                <MenuItem value="text">Text</MenuItem>
                                                                <MenuItem value="date">Date</MenuItem>
                                                                <MenuItem value="email">Email</MenuItem>
                                                                <MenuItem value="number">Number</MenuItem>
                                                                <MenuItem value="textarea">Textarea</MenuItem>
                                                                <MenuItem value="checkbox">Checkbox</MenuItem>
                                                                <MenuItem value="radio">Radio</MenuItem>
                                                            </Select>
                                                            {formErrors[getContentTypeErrorKey(contentIndex)] && (
                                                                <span className="error">{formErrors[getContentTypeErrorKey(contentIndex)]}</span>
                                                            )}
                                                        </FormControl>
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <Button
                                                            type="button"
                                                            onClick={() => removeContentField(contentIndex)}
                                                            variant="contained"
                                                            style={{
                                                                color: "#fff",
                                                                backgroundColor: "#d12c2c",
                                                                marginTop: "10px",
                                                                textTransform: 'capitalize'
                                                            }}>
                                                            Remove
                                                        </Button>
                                                    </Grid>
                                                    {(content.type === 'radio' || content.type === 'checkbox') && (
                                                        <Grid item xs={12}>
                                                            {content.options && content.options.map((option, optionIndex) => (
                                                                <Grid container spacing={2} key={optionIndex}>
                                                                    <Grid item xs={8}>
                                                                        <TextField
                                                                            fullWidth
                                                                            label={`Option ${optionIndex + 1}`}
                                                                            InputLabelProps={{ shrink: true }}
                                                                            value={option}
                                                                            onChange={(e) => handleContentOptionChange(contentIndex, optionIndex, e.target.value)}
                                                                            error={Boolean(formErrors[getContentOptionErrorKey(contentIndex, optionIndex)])}
                                                                            helperText={formErrors[getContentOptionErrorKey(contentIndex, optionIndex)] || ''}
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={2}>
                                                                        <Button
                                                                            type="button"
                                                                            onClick={() => removeContentOption(contentIndex, optionIndex)}
                                                                            variant="contained"
                                                                            style={{
                                                                                color: "#fff",
                                                                                backgroundColor: "#d12c2c",
                                                                                marginTop: "10px",
                                                                                textTransform: 'capitalize'
                                                                            }}>
                                                                            Remove
                                                                        </Button>
                                                                    </Grid>
                                                                </Grid>
                                                            ))}
                                                            <Button
                                                                type="button"
                                                                onClick={() => addContentOption(contentIndex)}
                                                                variant="contained"
                                                                color="primary"
                                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                                Add Option
                                                            </Button>
                                                            {formErrors[getContentOptionsGroupErrorKey(contentIndex)] && (
                                                                <span className="error">{formErrors[getContentOptionsGroupErrorKey(contentIndex)]}</span>
                                                            )}
                                                        </Grid>
                                                    )}
                                                </Grid>
                                            ))}
                                            <Button
                                                type="button"
                                                onClick={addContentField}
                                                variant="contained"
                                                color="primary"
                                                className="common-action-button"
                                                style={{ marginTop: "10px", textTransform: 'capitalize' }}>
                                                Add Content
                                            </Button>

                                            <Grid container className={classes.root} spacing={3}>
                                                <Grid item xs={4}>
                                                    <Button type="submit" className="btn-success" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} variant="contained" color="primary">Edit</Button>
                                                    <Button type="button" className="btn-cancel" style={{ marginTop: "10px", float: 'left', marginBottom: "15px", textTransform: 'capitalize' }} onClick={(e) => { e.preventDefault(); props.history.push('/review-form-list') }}>Cancel</Button>
                                                </Grid>
                                            </Grid>
                                        </form>
                                    </div>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                }
            />
            <Footer {...props} />
        </div>
    );
}
